import APPCONFIG from '../../constants/Config';
import {
  GET_PERMISSIONS,
  GET_PERMISSIONS_SUCCESS,
  GET_PERMISSIONS_ERROR,
} from '../../constants/ActionTypes';
// Model
/* eslint-disable import/named */
import { deserialize } from '../../models/permission';
/* eslint-enable import/named */

const initialSettings = APPCONFIG.permission;
const permission = (state = initialSettings, action) => {
  switch (action.type) {
    // GET PERMISSIONS
    case GET_PERMISSIONS:
      return {
        ...state,
        list: {
          ...state.list,
          error: null,
          loading: true,
        },
      };
    case GET_PERMISSIONS_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          error: action.error,
          loading: false,
        },
      };
    case GET_PERMISSIONS_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          elements: deserialize(action.data.data),
          loading: false,
        },
      };
    default:
      return state;
  }
};

export default permission;



// WEBPACK FOOTER //
// ./reducers/user/permission.js